module.exports = __webpack_public_path__ + "static/media/lobby-line.ad07f9d9.svg";